export default __webpack_public_path__ + "3129ef473d3bafd9e19475dbf0c8ac8a.svg";